import { useMutation } from '@tanstack/react-query';
import { aiService } from '../api/ai.service';
import { aiIdempotencyStore } from '../api/ai.idempotency';
import type { TaskPlanProposal, TaskPlanProposeRequest } from '../types';

/**
 * Propose mutation for the AI goal-to-task flow.
 * R1: propose never writes — no setQueryData, no invalidateQueries.
 * On success regenerates the idempotency key so the next apply uses a
 * fresh key per proposal (D6).
 */
/**
 * No cache invalidation on purpose: proposing writes nothing on the server, so there is
 * no cached data to go stale. The write happens in `useApplyTaskPlan`, which invalidates.
 */
export function useTaskPlanProposal(projectId: string, boardId: string) {
  return useMutation<TaskPlanProposal, unknown, TaskPlanProposeRequest>({
    mutationFn: (request) =>
      aiService.proposeTaskPlan(projectId, boardId, request.goal, request.timeZoneId),
    onSuccess: () => {
      aiIdempotencyStore.regenerate(projectId, boardId, 'goal-to-tasks');
    },
  });
}
